module.exports = __webpack_public_path__ + "static/media/pdf.worker.min.es5.f3640e91.data";